<template>
  <div>
    <sale-plan-count-list02 v-show="action === 'list'" @change-action="changeAction" />
    <sale-plan-count-detail v-if="action === 'detail'" :row-data="rowData" @change-action="changeAction" />
  </div>
</template>

<script>
import SalePlanCountList02 from './components/salePlanCountList02.vue'
import SalePlanCountDetail from './components/salePlanCountDetail.vue'
export default {
  components: {
    SalePlanCountList02,
    SalePlanCountDetail
  },
  data() {
    return {
      action: 'list',
      rowData: {}
    }
  },
  methods: {
    changeAction(type, rowData) {
      this.action = type
      this.rowData = rowData || {}
    }
  }
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/views/sale-plan-manage/salePlanCountList02.vue